export default __webpack_public_path__ + "static/media/Walk.84fed2e4.gif";